module.exports = __webpack_public_path__ + "static/media/icon4.857f24e7.svg";